import React, { useState } from "react";
import libraryBanner from "../../assets/liberary-banner.png";
import { newLogo } from "../../assets/Images";
import { StarIcon } from "@heroicons/react/24/solid";
import { HeartIcon as HeartOutline } from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";

export default function HeroLibrary() {
  const [isWishlisted, setIsWishlisted] = useState(false);

  return (
    <div className="w-full flex flex-col select-none">
      {/* Top Banner with Overlay */}
      <div
        className="w-full h-[450px] md:h-[500px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${libraryBanner})` }}
      >
        {/* <div className="absolute inset-0 bg-gradient-to-t from-black via-black/15 to-black/50"></div> */}

        {/* Glow Title Overlay
        <div className="relative z-10 text-center px-4 max-w-4xl animate-fade-down">
          <div className="border-2 border-secondary/40 py-6 px-8 bg-black/60 backdrop-blur-sm rounded-xl shadow-[0_0_30px_rgba(255,140,33,0.2)]">
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold font-anton tracking-wider text-white uppercase drop-shadow-[0_4px_10px_rgba(255,140,33,0.3)]">
              BOSS AMONGST BOSSES
            </h1>
            <div className="text-secondary font-oswald text-lg sm:text-xl md:text-2xl tracking-[0.25em] font-medium uppercase mt-2">
              DIGITAL LIBRARY
            </div>
          </div>
        </div> */}
      </div>

      {/* Detail Block */}
      <div className="w-full max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">

          {/* Left Details column */}
          <div className="lg:col-span-5 flex flex-col text-left">
            <h2 className="text-3xl sm:text-4xl font-bold font-oswald text-white uppercase tracking-wide mb-1">
              Lorem Ipsum
            </h2>
            <p className="text-secondary font-outfit text-sm sm:text-base font-medium mb-6">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>

            <div className="mb-6">
              <h3 className="text-white font-oswald text-lg font-semibold uppercase mb-2 tracking-wider">
                Overview
              </h3>
              <p className="text-gray-300 font-outfit text-sm sm:text-base leading-relaxed">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book.
              </p>
            </div>

            {/* Ratings (5 Stars) */}
            <div className="flex items-center gap-1.5 mb-8">
              {Array.from({ length: 5 }).map((_, i) => (
                <StarIcon key={i} className="w-5 h-5 text-secondary drop-shadow-[0_0_4px_rgba(255,140,33,0.5)]" />
              ))}
              <span className="text-xs text-neutral-400 font-outfit ml-2">(5.0 Rating)</span>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center gap-4">
              <button className="px-8 py-3 bg-secondary hover:bg-white text-black font-bold font-outfit rounded-lg text-sm sm:text-base uppercase tracking-wider transition-all duration-300 shadow-md hover:shadow-secondary/20 active:scale-95 outline-none focus:outline-none">
                Play Now
              </button>

              <button
                onClick={() => setIsWishlisted(!isWishlisted)}
                className="p-3 border border-secondary hover:bg-secondary/15 rounded-lg text-secondary transition-all duration-300 focus:outline-none"
              >
                {isWishlisted ? (
                  <HeartSolid className="w-6 h-6 text-secondary scale-110 transition-transform" />
                ) : (
                  <HeartOutline className="w-6 h-6 text-secondary" />
                )}
              </button>
            </div>
          </div>

          {/* Right Preview column */}
          <div className="lg:col-span-7 flex justify-center w-full">
            <div className="w-full max-w-lg aspect-[5/4] bg-black/85 rounded-xl border border-white p-6 flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,140,33,0.1)] hover:border-secondary hover:shadow-[0_0_30px_rgba(255,140,33,0.25)] transition-all duration-500">
              <img
                src={newLogo}
                alt="BAB Logo"
                className="object-contain h-1/2 w-1/2 mb-4 drop-shadow-[0_4px_8px_rgba(255,140,33,0.25)] "
              />
              <span className="text-secondary font-oswald text-base tracking-[0.2em] font-bold uppercase">
                Coming Soon
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
